import * as React from 'react';

import { format } from 'date-fns';
import { NavLink } from 'react-router-dom';

import styles from './ArticleFooter.module.styl';

interface IProps {
  categories: any;
  hashtags: any;
  publishDate: Date;
  lastUpdatedDate: Date;
}

export class ArticleFooter extends React.Component<IProps> {
  public render() {
    const { categories, hashtags, publishDate, lastUpdatedDate } = this.props;

    return (
      <footer className={styles.entryFooter}>
        {categories && categories.length > 0 && (
          <React.Fragment>
            <span className={styles.catLinks}>
              Posted in{' '}
              {categories.map((category: any) => (
                <NavLink
                  key={category.id}
                  to={`/${category.slug}`}
                  rel="category tag"
                >
                  {category.title}
                </NavLink>
              ))}
            </span>
            <span> | </span>
          </React.Fragment>
        )}
        {hashtags && hashtags.length > 0 && (
          <span className={styles.tagLinks}>
            Tagged{' '}
            {hashtags.map((hashtag: any) => (
              <NavLink key={hashtag.id} to={`/tags/${hashtag.slug}`} rel="tag">
                {hashtag.name}
              </NavLink>
            ))}
          </span>
        )}{' '}
        <div className={styles.dateInfo}>
          {publishDate && (!categories || categories.length === 0) && (
            <span>Posted on {format(new Date(publishDate), 'dd/MM/yyyy')}</span>
          )}
          {lastUpdatedDate && (
            <span className={styles.lastUpdatedAt}>
              Last updated on {format(new Date(lastUpdatedDate), 'dd/MM/yyyy')}
            </span>
          )}
        </div>
      </footer>
    );
  }
}
